import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { fromOpenDocActions } from '../actions';
import { IUploadDocsParams } from '../models/IUploadDocsParams.model';

export const openFileFeatureKey = 'openFile';

export interface openFileState {
  openFileRequest: IUploadDocsParams;
  openFileResponse: boolean;
  openFileFailure: IGenericError<ErrorResponse>;
  savedUploadedFile: string;
}

export const initialState: openFileState = {
  openFileRequest: undefined,
  openFileResponse: undefined,
  openFileFailure: undefined,
  savedUploadedFile: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromOpenDocActions.loadGetUploadedDocs, (state, action) => ({
    ...state,
    openFileRequest: action.request
  })),
  on(fromOpenDocActions.loadGetUploadedDocsSuccess, (state, action) => ({
    ...state,
    openFileResponse: action.response
  })),
  on(fromOpenDocActions.loadGetUploadedDocsFailure, (state, action) => ({
    ...state,
    openFileFailure: action.error
  })),
  // * -------------------  // * SAVE UPLOADED FILE ------------------- * /
  on(fromOpenDocActions.saveUploadedFileToStore, (state, action) => ({
    ...state,
    savedUploadedFile: action.savedBase64
  }))
);

export const getOpenFileRequest = (state: openFileState) => state.openFileRequest;
export const getOpenFileResponse = (state: openFileState) => {
  return state.openFileResponse;
};
export const getOpenFileFailure = (state: openFileState) => state.openFileFailure;

// * -------------------  // * GET SAVED UPLOADED FILE------------------- * /
export const getSavedBase64 = (state: openFileState) => state.savedUploadedFile;
